import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Zap, X } from "lucide-react";

interface TrendTipBannerProps {
  tip: { message: string; active: boolean };
  onDismiss: () => void;
}

const TrendTipBanner: React.FC<TrendTipBannerProps> = ({ tip, onDismiss }) => {
  return (
    <AnimatePresence>
      {tip.active && (
        <motion.div
          initial={{ y: "100%" }}
          animate={{ y: 0 }}
          exit={{ y: "100%" }}
          transition={{ ease: "easeInOut" }}
          className="fixed bottom-0 left-0 right-0 bg-text-secondary text-white p-3 flex justify-between items-center z-30 shadow-lg"
        >
          <div className="flex items-center gap-3">
            <Zap size={20} className="text-yellow-300" />
            <span className="font-semibold">Trend Alert:</span>
            <span>{tip.message}</span>
          </div>
          <button onClick={onDismiss} className="p-1 rounded-full hover:bg-black/20">
            <X size={18} />
          </button>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default TrendTipBanner;
